<template>
  <b-table
    class="deployments-table"
    :data="deployments"
    :checkable="false"
    backend-sorting
    :default-sort="[sortField, sortDirection]"
    @sort="onSort">
    <template slot-scope="props" slot="header">
      <span>{{ props.column.label }}</span>
    </template>
    <template slot-scope="props">
      <b-table-column label="Download" class="machine-icon" centered>
        <a @click="downloadPackage(props.row.id)">
          <svgicon name="download" height="30" width="30"></svgicon>
        </a>
      </b-table-column>
      <template v-for="item in keyValues(props.row)">
        <b-table-column
          :key="item.label"
          :label="item.label"
          :field="item.field"
          :sortable="sortableFields.includes(item.field)"
          :centered="item.centered">
          <router-link v-if="item.link" :to="item.link">
            {{ item.value }}
          </router-link>
          <span v-else-if="item.label === 'Status'" class="tag">
            {{ props.row.status.toUpperCase() }}
          </span>
          <div v-else>{{ item.value }}</div>
        </b-table-column>
      </template>
      <b-table-column label="Delete" centered>
        <a @click="deleteFunc(props.row.id)">
          <svgicon name="delete" height="30" width="30" color="#CC6365"></svgicon>
        </a>
      </b-table-column>
    </template>
  </b-table>
</template>

<script>
import mixin from '@/mixins/deployments';

export default {
  name: 'DeploymentsTable',
  mixins: [mixin],
  props: {
    deployments: {
      type: Array,
      required: true,
    },
    deleteFunc: {
      type: Function,
      required: true,
    },
    sortField: {
      type: String,
      required: true,
    },
    sortDirection: {
      type: String,
      required: true,
    },
    onSort: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        'Name',
        'Status',
        'Created',
      ],
      sortableFields: [
        'name',
        'status',
        'created',
      ],
    };
  },
};
</script>

<style lang="scss">

img.header {
  width: $table-icon-size;
  height: $table-icon-size;
}

div.deployments-table {
  th {
    svg {
      margin-right: 4px;
    }
  }

  td.machine-icon {
    width: $table-icon-size;
    text-align: center;
    img {
      width: $table-icon-size;
      max-width: $table-icon-size;
      height: $table-icon-size;
    }
  }

  th.date, td.date {
    width: $table-date-width;
  }
}

</style>
